export type BonusIcon = 'timer' | 'message' | 'users' | 'flame' | 'lightbulb'

export interface Bonus {
  number: string
  title: string
  intro?: string
  /** Label shown above the item chips. */
  listLabel?: string
  items?: string[]
  /** Optional label in front of the closing lines (e.g. "Result:"). */
  closingLabel?: string
  closing: string[]
  /** Label color from the bonus covers in the mockup. */
  color: string
  icon: BonusIcon
  /** Cover image. */
  image: string
}

export const bonuses: Bonus[] = [
  {
    number: '1',
    title: '5-Minute Practice Builder™',
    intro:
      'Answer a few key questions and quickly build a clear volleyball practice structure.',
    listLabel: 'Choose:',
    items: [
      'Main skill',
      'Player level',
      'Available time',
      'Player number',
      'Equipment',
      'Training priority',
    ],
    closingLabel: 'Result:',
    closing: ['A simple structure you can organize in minutes.'],
    color: '#16a34a',
    icon: 'timer',
    image: 'https://cdn.magicpatterns.com/uploads/hVdTWnTRRW5pYV7xCbJqPf/vv1_(1).webp',
  },
  {
    number: '2',
    title: 'Volleyball Coaching Cues Library™',
    listLabel: 'Short, useful coaching cues for:',
    items: [
      'Passing',
      'Setting',
      'Serving',
      'Attacking',
      'Defense',
      'Movement',
      'Communication',
    ],
    closing: ['Less talking.', 'Clearer corrections.', 'More repetitions.'],
    color: '#2563eb',
    icon: 'message',
    image: 'https://cdn.magicpatterns.com/uploads/5Xv4qoqeqnCKg5NCE4bHHf/vv2_(1).webp',
  },
  {
    number: '3',
    title: 'Mixed-Level Adaptation Kit™',
    intro: 'Turn one exercise into different levels.',
    listLabel: 'Make it:',
    items: [
      'Easier',
      'Harder',
      'Faster',
      'More controlled',
      'More competitive',
      'More decision-based',
    ],
    closing: ['Use the same core drill without losing half the group.'],
    color: '#ea580c',
    icon: 'users',
    image: 'https://cdn.magicpatterns.com/uploads/f4xeh3zofZ4SbUeRzkoEQR/vv3_(1).webp',
  },
  {
    number: '4',
    title: 'Ready-to-Run Warm-Ups™',
    intro:
      'Structured volleyball warm-ups that prepare players for the real objective of the practice.',
    closing: ['No random jogging.', 'No wasted opening minutes.', 'Start with purpose.'],
    color: '#dc2626',
    icon: 'flame',
    image: 'https://cdn.magicpatterns.com/uploads/bdwEWetfA5ut95iFVpSpb2/vv4_(1).webp',
  },
  {
    number: '5',
    title: 'Drill Fixer™',
    intro: 'What do you change when a drill is not working?',
    listLabel: 'Use quick adjustments for:',
    items: [
      'Too easy',
      'Too difficult',
      'Too much waiting',
      'Not enough contacts',
      'Poor spacing',
      'Low intensity',
      'Too much confusion',
    ],
    closing: ['Change one variable at a time instead of replacing the entire drill.'],
    color: '#7c3aed',
    icon: 'lightbulb',
    image: 'https://cdn.magicpatterns.com/uploads/dZcASWmsEsp47yq856V7oi/vv5_(1).webp',
  },
]
